import React, { Suspense, lazy } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import LoadingImg from "../Components/LoadingImg";
import { Route, Routes, Navigate } from "react-router-dom";
import NotFound from "../Components/NotFound.jsx";
import { useSelector } from "react-redux";
import GlobalRoutes from "./GlobalRoutes.jsx";
import ExpertRoutes from "./ExpertRoutes.jsx";
import StudentRoutes from "./StudentRoutes.jsx";
import ZoomMeetingComponent from "../Pages/Zoom/ZoomMeetingComponent.jsx";
const EnrolledPage = lazy(() =>
  import("../Pages/EnrolledCalenderPage/EnrolledPage.jsx")
);

const Routers = () => {
  const { UserData } = useSelector((state) => state.User);
  const roleId = UserData?.data?.roleId;
  return (
    <Suspense fallback={<LoadingImg />}>
      <Routes>
        {GlobalRoutes}
        {roleId === 2 ? (
          ExpertRoutes
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
        {roleId === 3 ? (
          StudentRoutes
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
        {roleId === 3 ? (
          <Route path="/weeklyenrolled" element={<EnrolledPage />} />
        ) : (
          <Route path="*" element={<Navigate to="/login" />} />
        )}
        <Route path="/zoom" element={<ZoomMeetingComponent />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default Routers;
